/* eslint-disable react/function-component-definition */
import PropTypes from "prop-types";

// sito components
import SitoContainer from "sito-container";

const Loader = (props) => {
  const { visible, minimal } = props;

  return (
    <SitoContainer
      id="preloader"
      ignoreDefault
      sx={{
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        opacity: visible ? 1 : 0,
        zIndex: visible ? 99999 : "-1 !important",
        transition: "all 500ms ease",
        position: minimal ? "absolute !important" : "fixed",
      }}
    >
      <SitoContainer
        className="row loader"
        ignoreDefault
        sx={{
          opacity: visible ? 1 : 0,
          zIndex: visible ? 99999 : "-1 !important",
          transition: "all 500ms ease",
          display: "flex !important",
          alignItems: "center !important",
        }}
      >
        <SitoContainer
          ignoreDefault
          className="loader-icon"
          sx={{
            width: "80px",
            opacity: visible ? 1 : 0,
            zIndex: visible ? 99999 : "-1 !important",
            transition: "all 500ms ease",
          }}
        />
      </SitoContainer>
    </SitoContainer>
  );
};

Loader.defaultProps = {
  minimal: false,
};

Loader.propTypes = {
  visible: PropTypes.bool.isRequired,
  minimal: PropTypes.bool,
};

export default Loader;
